import store from '../../store/index';
import RequestService from '../../services/request-service';
import { CASHOUT_ERROR_CODES } from '../../models/enums/mybets-const';
import { CASHOUT_TO_TOAST_TYPES } from '../../models/enums/toast-enums';
import { EventBus } from '../event-bus-service';
import { setToastNotification } from '@bto-services/toast-notification';
import { getToastAdditionalTime } from 'bto-models/toast-notification';
import { BtoPublicBus } from '../bto-event-bus';
import { BTO_EMITERS } from '../../models/enums/bto-event-bus-const';
// import { openModal } from '@bto-services/modal';

/**
 * handle negotiations
 */
export default class CashoutService extends RequestService {
  constructor(amount = 0, betId = 0) {
    super();

    this.endpoint = this.$config.endpoints.betSlipCashout;
    this.method = 'post';

    const { authorizationHeaders } = this.$config;
    const { connectionId } = this.$config.customHeaders;
    this.headers = { ...authorizationHeaders, connectionId };
    // this.addHeader('ConnectionId', this.$config.customHeaders.connectionId);

    this.postParams = {
      // eslint-disable-next-line no-undef
      // ExternalUserID: APP_SETTINGS.player.id,
      // UserId: 0,
      Amount: amount,
      betSlipGroupID: betId,
      Culture: APP_SETTINGS.player.language,
    };
  }
  static processCashout(resp) {
    store.commit('addCashoutBets', resp);
  }

  static processCashoutMsg(resp) {
    // if cashout is successful or error add toast notification
    if (resp.ErrorCode === CASHOUT_ERROR_CODES.SUCCESS || resp.ErrorCode === CASHOUT_ERROR_CODES.ERROR) {
      const key = resp.BetslipGroupId;
      const expireTime = Date.now() + getToastAdditionalTime();
      setToastNotification(key, {
        playerId: APP_SETTINGS.player.id,
        expireTime,
        message: resp.Message,
        status: CASHOUT_TO_TOAST_TYPES[resp.ErrorCode],
      });
      // FEAT: if modal is needed for cashout uncomment this code
      // openModal({
      //   title: '',
      //   message: resp.Message,
      // });
    }
    this.emitExetrnalCashout(resp);
    EventBus.$emit('cashedOutMsg', resp);
  }

  /**
   * @private
   * Emit successfull cashout to external listeners
   * @param {*} resp 
   */
  static emitExetrnalCashout(resp) {
    if (resp.ErrorCode === CASHOUT_ERROR_CODES.SUCCESS) {
      BtoPublicBus.emit(BTO_EMITERS.CASHED_OUT, resp);
      window.postMessage({ action: "balanceUpdated" }, "*");
    }
  }
}
